export default __webpack_public_path__ + "static/media/traffic.9dd741f5.svg";